import {
  applyAvailabilityFacetCounts,
  planAvailabilityFacetRequests,
} from "./availabilityFacetCount";

type SearchClient = {
  search: (requests: unknown, ...rest: unknown[]) => Promise<unknown>;
};

export const withAvailabilityFacetCounts = <T extends SearchClient>(
  client: T,
): T => ({
  ...client,
  search: (async (requests: unknown, ...rest: unknown[]) => {
    if (!Array.isArray(requests)) {
      return client.search(requests, ...rest);
    }

    const plan = planAvailabilityFacetRequests(requests);
    const response = await client.search(plan.requests, ...rest);
    if (!response || typeof response !== "object") {
      return response;
    }

    return applyAvailabilityFacetCounts(response, plan);
  }) as T["search"],
});

export default withAvailabilityFacetCounts;
